import { useCallback, useState } from "react";
import { toast } from "react-toastify";

import ChangePasswordUI from "./ChangePasswordModal.ui.tsx";
import { ChangePasswordModalData, ExternalProps } from "./ChangePasswordModal.types.tsx";

import { authResetPassword } from "../../services/auth.services.tsx";

export const useChangePasswordModal = ({ resetToken, onSuccess }: ExternalProps) => {
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [data, setData] = useState<ChangePasswordModalData>({
    password: "",
    confirmPassword: "",
  });

  const open = () => setShow(true);

  const close = () => {
    setShow(false);
    setValidated(false);
    setData({ password: "", confirmPassword: "" });
    setShowPassword(false);
    setShowConfirmPassword(false);
  };

  const onTogglePassword = () => setShowPassword((p) => !p);
  const onToggleConfirmPassword = () => setShowConfirmPassword((p) => !p);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      setValidated(true);

      if (data.password !== data.confirmPassword) return;
      if (!e.currentTarget.checkValidity()) return;

      await authResetPassword(resetToken, data.password);
      onSuccess?.();
      close();
      toast.success("Your password has been changed successfully");
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "API Error";
      toast.error(`Error: ${message}`);
    }
  };

  const modal = (
    <ChangePasswordUI
      show={show}
      close={close}
      data={data}
      validated={validated}
      showPassword={showPassword}
      showConfirmPassword={showConfirmPassword}
      onTogglePassword={onTogglePassword}
      onToggleConfirmPassword={onToggleConfirmPassword}
      onChange={onChange}
      onSubmit={onSubmit}
    />
  );

  return { open, close, modal };
};
